import { useState, useEffect, useCallback } from "react";
import CountUp from 'react-countup';

function Percentile(props) {
    const { size, percentile, colourPalette, scaleIndex, colour } = props;

    const [percentileBackgroundColour, setPercentileBackgroundColour] = useState("bg-blue-gray-300")
    const [textColor, setTextColor] = useState("text-blue-gray-50")

    const handleSetColour = useCallback(async () => {
        setTimeout(() => {
            setPercentileBackgroundColour(
                colourPalette[scaleIndex]
                    ? `lg:bg-${colour}-${colourPalette[scaleIndex]}`
                    : `lg:bg-${colour}-${colourPalette[colourPalette.length - 1]}`
            );
            setTextColor(
                colourPalette[scaleIndex]
                    ? `text-${colour}-${colourPalette[scaleIndex]}`
                    : `text-${colour}-${colourPalette[colourPalette.length - 1]}`
            );
        }, 100);
    }, [colour, colourPalette, scaleIndex]);

    useEffect(() => {
        handleSetColour(percentile)
    }, [handleSetColour, percentile]);
    

    return (
        <div className={
            "h-full py-4 lg:py-0 lg:px-8 flex items-center justify-start lg:justify-center lg:text-blue-gray-50 lg:shadow-sm " + textColor +
            " transition transition-color duration-4000 ease-in-out bg-transparent " + percentileBackgroundColour +
            (size === " large" ? " h-full w-full rounded-xl " : " w-full rounded-xl")
        }>
            <span className={(size === "large" ? "lg:text-5xl text-4xl  " : "text-xl  ") + "font-medium"}>
                <CountUp end={percentile} duration={4}/>
            </span>
            <span className={(size === "large" ? "text-xl  " : "text-md  ") + "text-2xl"}>%ile</span>
        </div>
    )
}

export default Percentile;
